import { loadDataFromElement } from "../utils/hydrate-data";

// load the auth provider(s) data (json) from a script tag with id "auth-providers" if available
type AuthProviderInfo = { name: string; slug: string; url: string };
export const authProviders = loadDataFromElement<AuthProviderInfo[]>(
  "auth-providers",
  [],
);
